<div class="p-4 rounded-lg border maintenance text-center">
  <h2 class="m-0 text-center">{{'COMMON.LABEL.MAINTENANCE_MESSAGE' | translate}}</h2>
</div>